import { Constants as MoltenConstants } from '@leverege/molten';
import Relationships from "./relationship/index.js";
import Routes from "./route/index.js";
import Reducers from "./reducer/index.js";
import Attributes from "./attributes/index.js";
import Blockers from "./blockers/index.js";
import Analyzers from "./analyzer/index.js";
import DataSources from "./dataSource/index.js";
import Actions from "./actions/index.js";
import Views from "./views/index.js";
import ItemActionHooks from "./itemActionHook/index.js";
import * as Constants from "./constants/index.js";
import PluginInitializer from "./PluginInitializer.js";
const plugins = {
  Relationships,
  Routes,
  Reducers,
  Attributes,
  Blockers,
  Analyzers,
  DataSources,
  Actions,
  Views,
  ItemActionHooks,
  Constants
};
export default {
  ...plugins,
  install: molten => {
    molten.addPlugin(MoltenConstants.INITIALIZER, PluginInitializer);
  }
};